import { render, staticRenderFns } from "./Listing-Footer.vue?vue&type=template&id=66177c2c"
import script from "./Listing-Footer.vue?vue&type=script&lang=js"
export * from "./Listing-Footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports